module.exports = __webpack_public_path__ + "img/gem_gemlandcoins.febb7de.png";